import { IMessageDto } from '@/Models/Chat'
import React from 'react'
import { StyledTextMessage } from '../ChatMessages.style';
import { DateService } from '@/Services/DateService';

type Props = {
  data: IMessageDto;
  isSender: boolean;
}

const TextMessage = ({ data, isSender }: Props) => {
  return (
    <StyledTextMessage isSender={isSender} className='chat-messages__item chat-messages__text'>
      { data.text }
      <span className='chat-messages__time-text'>&nbsp;{ DateService.toHHMM(data.createdAt) }</span>
    </StyledTextMessage>
  )
}

export default TextMessage;
